import React, { ReactElement } from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { KeyValue } from "models/utilTypes/keyValue";
import { TranslationKeys } from "translations";
import { SupplierDetailsListProps } from "models/propTypes/supplierPropTypes";
//#endregion
//#region components
import { Address, DetailsTableView } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const SupplierDetailsList: React.FC<SupplierDetailsListProps> = (props) => {
  const { supplier } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const getDetailsList = () => {
    const detailsList: Array<KeyValue<string, string | ReactElement> | typeof ACTION_SEPARATOR> = [
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OrgNr),
        supplier?.orgNr ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.PG_BG),
        supplier?.pg ?? supplier?.bg ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentTerms),
        supplier?.paymentTerms !== undefined
          ? `${supplier.paymentTerms} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Days)}`
          : "-"
      ),
      ACTION_SEPARATOR,
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Address),
        (
          <Address
            street1={supplier?.street1}
            street2={supplier?.street2}
            zipCode={supplier?.zipCode}
            city={supplier?.city}
            country={supplier?.countryCode ? LocalizationHelperInstance.getFormattedMessage(supplier.countryCode) : ""}
          ></Address>
        )
      ),
    ];

    return detailsList;
  };

  const onClickAllInfo = () => {
    navigate(UrlHelper.formatPath(`/Supplier/${supplier.id}/Settings`), {
      state: { background: location },
    });
  };

  return (
    <DetailsTableView
      detailsList={getDetailsList()}
      buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllInfo)}
      buttonOnClick={onClickAllInfo}
    ></DetailsTableView>
  );
};

export default SupplierDetailsList;
